import styled from 'styled-components/native';
import style, { hpx, wpx } from '../../styles';

export const Container = styled.View`
  padding: ${hpx(4)} ${wpx(8)};
  background: #FFFFFF;
`;

export const ItemContainer = styled.TouchableOpacity`
  flex-direction: row;
  width: 100%;
  align-items: stretch;
  opacity: ${props => (props.disabled ? 0.6 : 1)};
  background-color: #FFFFFF;
  padding: ${hpx(10)} ${wpx(8)};
  border-radius: 12px;
  border-width: 1px;
  border-color: #F0F0F0;
`;

export const TextContainer = styled.View`
  flex: 1;
  justify-content: space-between;
`;

export const ContentWrapper = styled.View`
`;

export const CategoryName = styled.Text`
  color: ${props => props.theme.colors.primary};
  font-size: ${style.fonts.medium};
  margin-bottom: ${hpx(12)};
  margin-top: ${hpx(16)};
  font-family: ${style.fontName.ubuntuBold};
`;

export const Title = styled.Text`
  color: #1A1A1A;
  font-size: ${style.fonts.small};
  font-family: ${style.fontName.ubuntuBold};
  line-height: ${hpx(22)};
`;

export const Description = styled.Text`
  color: #666666;
  font-size: ${style.fonts.xxsmall};
  font-family: ${style.fontName.ubuntuRegular};
  line-height: ${hpx(18)};
  margin-top: ${hpx(4)};
`;

export const PriceRow = styled.View`
  flex-direction: row;
  align-items: center;
  margin-top: ${hpx(10)};
`;

export const Prices = styled.Text`
  color: ${props => props.theme.colors.primary};
  font-size: ${style.fonts.small};
  font-family: ${style.fontName.ubuntuBold};
`;

export const PricePrefix = styled.Text`
  color: #999999;
  font-size: ${style.fonts.xxsmall};
  font-family: ${style.fontName.ubuntuRegular};
  margin-right: 4px;
`;

export const ImageContainer = styled.View`
  width: 100px;
  height: 100px;
  border-radius: 8px;
  overflow: hidden;
  margin-left: ${wpx(12)};
`;

export const Image = styled.Image`
  width: 100%;
  height: 100%;
  background-color: #F5F5F5;
`;

export const NoImagePlaceholder = styled.View`
  width: 100px;
  height: 100px;
  border-radius: 8px;
  background-color: #F8F8F8;
  align-items: center;
  justify-content: center;
`;

export const PlaceholderImage = styled.View`
  width: 100%;
  height: 100%;
  background-color: #FFFFFF;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
`;

export const PlaceholderText = styled.Text`
  font-size: 32px;
`;

export const Separator = styled.View`
  height: ${hpx(2)};
`;

export const StatusBadge = styled.View`
  background-color: ${props => props.soldOut ? '#F5F5F5' : '#FFF0F0'};
  padding: ${hpx(6)} ${wpx(12)};
  border-radius: 6px;
  align-self: flex-start;
  margin-top: ${hpx(10)};
`;

export const StatusText = styled.Text`
  color: ${props => props.soldOut ? '#888888' : '#E74C3C'};
  font-size: ${style.fonts.xxsmall};
  font-family: ${style.fontName.ubuntuBold};
`;

export const FooterContainer = styled.View`
  position: initial;
`;
